import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class ContractScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {currentContract: {id: null, 
                                        name: "", 
                                        description: "",
                                        start: null,
                                        end: null,
                                        value: 0.0
                                         }};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeDescription = this.handleChangeDescription.bind(this); 
        this.handleChangeStart = this.handleChangeStart.bind(this);  
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.handleChangeValue = this.handleChangeValue.bind(this);  
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.contract && this.props.args.contract.length > 0) {
            BaseApi.get("/contract", {headers: {
                'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {id: this.props.args.contract}, withCredentials: true})
            .then(res => { 
                this.setState({currentContract: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/contract', this.state.currentContract, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentContract = this.state.currentContract
            currentContract.id = res.data.id
            this.setState({currentContract: currentContract})
            this.props.args.contract = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    openContractPrograms() {
        this.props.navigate("contract-programs", 
        {caller: "contract", callargs: this.props.args, contractid: this.state.currentContract.id, contract: this.state.currentContract})    
    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "contract", callargs: this.props.args, refrecid: this.state.currentContract.id})    
    }

    handleChangeName(event) {
        var currentContract = this.state.currentContract
        currentContract.name = event.target.value
        this.setState({currentContract: currentContract})
    }

    handleChangeDescription(event) {
        var currentContract = this.state.currentContract
        currentContract.description = event.target.value
        this.setState({currentContract: currentContract})
    }

    handleChangeStart(event) {
        var currentContract = this.state.currentContract
        currentContract.start = event.target.value
        this.setState({currentContract: currentContract})
    }

    handleChangeEnd(event) {
        var currentContract = this.state.currentContract
        currentContract.end = event.target.value
        this.setState({currentContract: currentContract})
    }

    handleChangeValue(event) {
        var currentContract = this.state.currentContract
        currentContract.value = event.target.value
        this.setState({currentContract: currentContract})      
    }

    render() {
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Контракт"}/>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                <label for="name"> Наименование:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentContract.name} onChange={this.handleChangeName} />
                                <label for="description">Описание:</label>
                                <input type="text" class="form-control w-100" id="description"  value={this.state.currentContract.description} onChange={this.handleChangeDescription} />
                                <label for="start">Начало:</label>
                                <input type="date" class="form-control" id="start"  value={this.state.currentContract.start} onChange={this.handleChangeStart} />
                                <label for="end">Завершение:</label>
                                <input type="date" class="form-control" id="end"  value={this.state.currentContract.end} onChange={this.handleChangeEnd} />
                                <label for="end">Сумма:</label>
                                <input type="number" class="form-control" id="value"  value={this.state.currentContract.value} onChange={this.handleChangeValue} />
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        {this.state.currentContract.id && 
                        <div class="row mt-1">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openContractPrograms()}}>Программы</button>   
                        </div>
                        }
                        {this.state.currentContract.id && 
                        <div class="row mt-1">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openRefs()}}>Ссылки</button>   
                        </div>}
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/contract.js